/**
 * OperationsInputsField
 */
import { ReactNode } from 'react';
import { cn } from 'src/utils/utility';
import { styled } from '@mui/material/styles';

export type FieldLabelBorder = 'dashed' | 'solid' | 'none';

interface IOperationsInputsFieldProps {
  label?: ReactNode;
  children: ReactNode;
  border?: FieldLabelBorder;
}

// Styled component to provide consistent styling for all children elements
const StyledChildrenContainer = styled('div')(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '16px',
  // Apply these styles to all children, including MUI components
  '& .MuiBox-root, & div, & span, & p': {
    fontSize: 'inherit',
    lineHeight: 'inherit',
  },

  // Responsive styling for larger screens
  [theme.breakpoints.up(1520)]: {
    fontSize: '16px',
    lineHeight: '20px',

    '& .MuiBox-root, & div, & span, & p': {
      fontSize: 'inherit',
      lineHeight: 'inherit',
    },
  },
}));

export const FieldLabel: React.FC<IOperationsInputsFieldProps> = ({ label, children, border }) => (
  <div
    className={cn(
      'mb-14 xl:mb-16 pb-14 xl:pb-16 border-b border-neutral-20 last:mb-0 last:pb-0 last:border-0',
      border === 'dashed' && 'border-dashed',
      border === 'solid' && 'border-solid',
      border === 'none' && 'border-none'
    )}
  >
    {label && (
      <div className='mb-10'>
        <span className='text-14 xl:text-16 leading-16 xl:leading-18 text-blue_grey-30'>{label}</span>
      </div>
    )}
    <StyledChildrenContainer>{children}</StyledChildrenContainer>
  </div>
);
